<template>
	<!-- <div id="status-container" v-show="uploadStatus"> -->
	<div id="status-container" v-if="false">
		<span v-if="uploadStatus == 'processing'">Processing {{ processedFilesForUpload }} / {{ totalUploadFiles }}</span>
		<span v-else>Syncing with cloud {{ filesUploaded }} / {{ totalUploadFiles }}</span>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
	computed: {
		...mapState("Projects", ["filesUploaded", "uploadStatus", "processedFilesForUpload", "totalUploadFiles"]),
	},
};
</script>

<style lang="scss">
#status-container {
	grid-area: status;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 12px;
	padding-top: 12px;
}
</style>
